import { createSlice } from "@reduxjs/toolkit";

import { ICertificateStore } from "../types";

const initialState: ICertificateStore = {
  certificates: [],
};

export const certificateSlice = createSlice({
  name: "certificate",
  initialState,
  reducers: {
    setCertificates: (state, { payload }) => {
      state.certificates = payload;
    },
  },
});

export const { setCertificates } = certificateSlice.actions;
